var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDecorImage3Bottom = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 61 65",
  preserveAspectRatio: "xMidYMid meet"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1a7cec",
  d: "M42.73 3.222c.172-3.066-3.888-4.437-5.608-1.894l-.164.268-5.21 9.386A22.38 22.38 0 0 1 9.702 22.367l-5.414-.603c-4.11-.457-5.954 5.006-2.408 7.134l4.672 2.803a22.4 22.4 0 0 1 10.636 22.421l-.939 6.459c-.614 4.236 5.102 6.167 7.18 2.424l3.168-5.705A22.38 22.38 0 0 1 48.64 45.915l8.93.994c3.286.366 4.76-4.003 1.925-5.706L51.79 36.58a22.4 22.4 0 0 1-10.635-22.42l1.542-10.626z"
})));
export default SvgDecorImage3Bottom;